<template>
  <component :is="componentType" v-bind="currentProps" />
</template>

<script>
import VideoJsPlayer from './VideoJsPlayer.vue';
import EmbedVideoPlayer from './EmbedVideoPlayer.vue';

export default {
  name: "SrVideoPlayer",
  props: {
    video: { type: Object, required: true },
    autoplay: { type: Boolean, default: false }
  },
  data() {
    return {
      cacheTimestamp: new Date().getTime()
    };
  },
  computed: {
    videoHostId() {
      return this.video.video_host_id;
    },
    url() {
      return this.video.videoUrl
          ? this.video.videoUrl
          : `https://video-content.sportsrecruits.com/${this.videoHostId}/hls/index.m3u8?c=${this.cacheTimestamp}`;
    },
    type() {
      return this.video.videoType ?? 'application/x-mpegURL';
    },
    currentProps() {
      switch (this.componentType) {
        case EmbedVideoPlayer:
          return {
            video: this.video,
            autoplay: this.autoplay
          };
        default:
          return {
            sourceUrl: this.url,
            type: this.type,
            autoplay: this.autoplay
          };
      }
    },
    componentType() {
      if (this.video.videoType === 'embed') {
        return EmbedVideoPlayer;
      }

      return VideoJsPlayer;
    }
  }
};
</script>
